import { __assign, __rest } from "tslib";
import React from 'react';
import { Box } from '@marvelapp/ui';
import { SpecsPanelProperty } from '@marvelapp/ui-internal';
export default function PanelPropertyItem(_a) {
    var children = _a.children, fontFamily = _a.fontFamily, label = _a.label, props = __rest(_a, ["children", "fontFamily", "label"]);
    return (React.createElement(Box, __assign({ marginBottom: 3, width: 1 / 2 }, props),
        React.createElement(SpecsPanelProperty, { fontFamily: fontFamily, label: label }, children)));
}
